import React from 'react';
import { useTranslate } from '@agilepoint/wat-react';


export function useValidateHelperFunctions() {
    const translate = useTranslate();
    const validateTextLength = React.useCallback((value: string) => {
        if (value && value.length > 30) {
            return translate('modules.createNewApp.steps.basicSettings.validationMessages.MobileAppNameMaxCharacter');
        }

    }, [translate]);

    return ({
        validateTextLength
    });
}
